import { Link } from "react-router-dom"
import { Button, Flex, Typography } from "antd"

import refund from "@src/app/assets/icons/refund.svg"
import { paths } from "@src/app/paths"

export const RefundSuccess = () => {
  return (
    <Flex align="center" gap={24} vertical>
      <img alt="refund" src={refund} style={{ width: "200px" }} />
      <div>
        <Typography.Title level={3} style={{ margin: 0, textAlign: "center" }}>
          Successfully
        </Typography.Title>
        <Typography.Paragraph style={{ margin: 0, textAlign: "center" }}>
          You have successfully requested a refund, your transaction is being{" "}
          <br />
          processed, funds will soon be credited to the wallet
        </Typography.Paragraph>
      </div>
      <Link id="GENERATED_ID_REFUNDSUCCESS_LINK_VOID_1" to={paths.transactions}>
        <Button
          block
          id="GENERATED_ID_REFUNDSUCCESS_BUTTON_GO_BACK_1"
          size="large"
          type="primary"
        >
          Go back
        </Button>
      </Link>
    </Flex>
  )
}
